import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Table, Button } from 'semantic-ui-react';
import moment from 'moment-timezone';
moment.tz.setDefault('Asia/Seoul');
import cm from 'helpers/commons';
import { SikdaePolicyMod } from './Modal';

import * as cm_action from 'actions/commons';
import storage from '../../helpers/storage';

class PolicyList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      clickTime: moment().format('YYYY-MM-DDHH:mm:ss')
    };
  }

  //수정 Modal Show
  modShowModal = (dimmer, data) => () => {
    const { commonFn } = this.props;

    if (dimmer) {
      commonFn.changeWeek({
        type: 'week',
        name: 'value',
        value: data.day.value
      });
    }

    this.setState({
      dimmer,
      data,
      open: true,
      clickTime: moment().format('YYYY-MM-DDHH:mm:ss')
    });
  };

  //수정 Modal Close
  modCloseModal = () => {
    this.setState({ open: false });
  };
  render() {
    const { sikdaePolicy, groupName, sikdaePolicyModFn } = this.props.PolicyListFn,
      { open, dimmer, data } = this.state,
      modal = {
        open: open,
        dimmer: dimmer,
        data: data,
        close: this.modCloseModal,
        sikdaePolicy: sikdaePolicy,
        groupName: groupName,
        sikdaePolicyModFn: sikdaePolicyModFn
      };

    let policyInfo = sikdaePolicy
      ? sikdaePolicy.data.policy.map((data) => {
          let color = data.isactive ? '#000000' : '#999999';
          const { auth } = (storage.get('info') || {}).auth || {};
          let policyChangeBtn = null;
          (auth || []).some((authData) => {
            // 전체 권한 일 때
            if (authData === '*:*') {
              policyChangeBtn = (
                <Button inverted color="black" style={{ padding: 0 }} onClick={this.modShowModal(true, data)}>
                  변경
                </Button>
              );
            }
          });
          let useTime = '';
          let timeComparison1 = false;
          let timeComparison2 = false;
          let timeComparison3 = false;
          const startHour = cm.policyUsedTimeHourSplit(data.startTime);
          const endHour = cm.policyUsedTimeHourSplit(data.endTime);
          const startMin = cm.policyUsedTimeMinSplit(data.startTime);
          const endMin = cm.policyUsedTimeMinSplit(data.endTime);
          const startHour2 = cm.policyUsedTimeHourSplit(data.startTime2);
          const endHour2 = cm.policyUsedTimeHourSplit(data.endTime2);
          const startMin2 = cm.policyUsedTimeMinSplit(data.startTime2);
          const endMin2 = cm.policyUsedTimeMinSplit(data.endTime2);
          const startHour3 = cm.policyUsedTimeHourSplit(data.startTime3);
          const endHour3 = cm.policyUsedTimeHourSplit(data.endTime3);
          const startMin3 = cm.policyUsedTimeMinSplit(data.startTime3);
          const endMin3 = cm.policyUsedTimeMinSplit(data.endTime3);

          if (startHour > endHour) {
            timeComparison1 = true;
            timeComparison2 = true;
            timeComparison3 = true;
          }
          if (startHour === endHour && startMin >= endMin) {
            timeComparison1 = true;
            timeComparison2 = true;
            timeComparison3 = true;
          }
          if (data.startTime2 && data.endTime2) {
            if (!timeComparison1 && startHour2 > endHour2) {
              timeComparison2 = true;
              timeComparison3 = true;
            }
            if (!timeComparison1 && startHour2 === endHour2 && startMin2 === endMin2) {
              timeComparison2 = true;
              timeComparison3 = true;
            }
            if (!timeComparison1 && startHour === endHour2 && startMin >= endMin2) {
              timeComparison2 = true;
              timeComparison3 = true;
            }
          }
          if (data.startTime3 && data.endTime3) {
            if (!timeComparison2 && startHour3 > endHour3) {
              timeComparison3 = true;
            }
            if (!timeComparison2 && startHour3 === endHour3 && startMin3 === endMin3) {
              timeComparison3 = true;
            }
            if (!timeComparison2 && startHour === endHour3 && startMin === endMin3) {
              timeComparison3 = true;
            }
            if (!timeComparison2 && startHour2 === endHour3 && startMin2 === endMin3) {
              timeComparison3 = true;
            }
            if (!timeComparison2 && startHour3 === endHour3 && startMin3 > endMin3) {
              timeComparison3 = true;
            }
          }
          let startTime = `사용 시간  :  ${data.startTime} ~ ${data.endTime} ${timeComparison1 ? '(내일)' : ''}`;
          let startTime2 = `${
            data.startTime2
              ? ', ' +
                data.startTime2 +
                ((timeComparison2 && startHour2 < endHour) || (timeComparison1 && startHour2 >= endHour)
                  ? '(내일)'
                  : '') +
                ' ~ ' +
                data.endTime2 +
                (timeComparison2 ? '(내일)' : '')
              : ''
          }`;
          let startTime3 = `${
            data.startTime3
              ? ', ' +
                data.startTime3 +
                ((timeComparison3 && startHour3 < endHour2) || (timeComparison2 && startHour3 >= endHour2)
                  ? '(내일)'
                  : '') +
                ' ~ ' +
                data.endTime3 +
                (timeComparison3 ? '(내일)' : '')
              : ''
          }`;
          useTime = startTime + startTime2 + startTime3;

          const { supplyType } = data;
          let payOption = '';
          if (supplyType === 'BATCH') {
            payOption = '일괄 지급';
          } else if (supplyType === 'WORKINGDAY') {
            payOption = '영업일 지급';
          } else if (supplyType === 'MONTHDAY') {
            payOption = '총 일수 지급';
          }

          return (
            <Table.Row key={data.idx} style={{ color: color }}>
              <Table.Cell verticalAlign="top">{data.name}</Table.Cell>
              <Table.Cell verticalAlign="top">{data.isactive ? '활성' : '비활성'}</Table.Cell>
              <Table.Cell verticalAlign="top">
                {data.type === 'DAY' ? '일일' : null}
                {data.type === 'LONGTERM' ? '장기' : null}
                {data.type === 'INFINITE' ? '무제한' : null}
                {data.type === 'DEMAND' ? '신청' : null}
              </Table.Cell>
              <Table.Cell textAlign="right" verticalAlign="top">
                {cm.numberComma(data.amount)}
              </Table.Cell>
              <Table.Cell verticalAlign="top" className="demand">
                {data.demand ? (
                  <div>
                    {'신청 시간 : ' +
                      cm.hhmm(new Date(data.demand.starttime)) +
                      '~' +
                      cm.hhmm(new Date(data.demand.expiretime), 'end')}
                    {cm.timeComparison(data.demand.starttime, data.demand.expiretime) ? '' : ' (내일)'}
                    <br />
                  </div>
                ) : null}
                <div>
                  {useTime}
                  <br />
                </div>
                <div>
                  {`사용 요일  :  ${data.day.text}`}
                  <br />
                </div>
                <div>
                  {`공휴일 설정  :  ${data.holidayUseOptionName}`}
                  <br />
                </div>
                <div>
                  {`지급 기준  :  + ${data.deposit}`}
                  <br />
                </div>
                {data.onceLimitAmount ? (
                  <div>{`1회 결제금액 제한  :  ${cm.numberComma(data.onceLimitAmount)}`}</div>
                ) : null}
                {data.limitAmount ? <div>{`일일결제금액제한  :  ${cm.numberComma(data.limitAmount)}`}</div> : null}
                {cm.isValidNumber(data.maxHoldLimitAmount) ? (
                  <div>{`최대보유한도금액제한  :  ${cm.numberComma(data.maxHoldLimitAmount)}`}</div>
                ) : null}
                {supplyType !== 'NONE' ? <div>{`지급 옵션 : ${payOption}`}</div> : null}
              </Table.Cell>
              <Table.Cell className="table-cell-btn" verticalAlign="top" textAlign="right">
                {policyChangeBtn}
              </Table.Cell>
            </Table.Row>
          );
        })
      : null;

    return (
      <div>
        <Table basic unstackable>
          <Table.Header>
            <Table.Row className="table-title">
              <Table.HeaderCell colSpan="6">
                <span>식대 정책</span>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>정책명</Table.HeaderCell>
              <Table.HeaderCell>상태</Table.HeaderCell>
              <Table.HeaderCell>종류</Table.HeaderCell>
              <Table.HeaderCell textAlign="right" style={{ width: 90 }}>
                지급 식대
              </Table.HeaderCell>
              <Table.HeaderCell>세부정보</Table.HeaderCell>
              <Table.HeaderCell className="table-cell-btn"></Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {sikdaePolicy ? (
              policyInfo
            ) : (
              <Table.Row key="empty">
                <Table.Cell colSpan="6">검색 결과가 없습니다.</Table.Cell>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
        <SikdaePolicyMod key={this.state.open} modal={modal} />
      </div>
    );
  }
}

PolicyList = connect(
  (state) => ({
    sikdaePolicy: state.commons.sikdaePolicy
  }),
  (dispatch) => ({
    commonFn: bindActionCreators(
      {
        changeWeek: cm_action.ReduxDataSet,
        changeTime: cm_action.ReduxDataSet
      },
      dispatch
    )
  })
)(PolicyList);

export default PolicyList;
